export default {
  meta: {
    title: '整体情况',
    parentPath: ['/storemanage'],
  },
};
